import * as z from "zod";
import type { TFunction } from "i18next";

export const createStructureSchema = (t: TFunction) =>
  z.object({
    complexId: z
      .string()
      .min(1, t("management.structures.validation.complexRequired")),
    name: z.string().min(1, t("management.structures.validation.nameRequired")),
  });

export const editStructureSchema = (t: TFunction) =>
  z.object({
    name: z.string().min(1, t("management.structures.validation.nameRequired")),
  });

export type StructureFormData = z.infer<
  ReturnType<typeof createStructureSchema>
>;

export type EditStructureFormData = z.infer<
  ReturnType<typeof editStructureSchema>
>;
